import * as constants from "../../EventSettings/constants";

export const loginSettingsOptions = (accessPreModeration, guest, authRequire, hasRegistrationFields, participationType, email) => {
    let options = {};
    const firstScreenOptionTitle = `Имя ${hasRegistrationFields ? 'и полями регистрации' : ''}`;
    const isParticipationTypeSelect = !authRequire && participationType === 'hybrid';

    if (authRequire || isParticipationTypeSelect) {
        options[constants.LOGIN_OPTION_INFO] = 'Блок с информацией о мероприятии';
    };

    if (isParticipationTypeSelect) {
        options[constants.LOGIN_OPTION_PARTICIPATION_TYPE_SELECT] = 'Экран выбора формата участия';
    }

    if (email || guest) {
        options[constants.LOGIN_OPTION_EMAIL_REQUEST] = `Первый экран - С полем ${guest ? firstScreenOptionTitle : 'Email'}`;
    }

    if (email) {
        options[constants.LOGIN_OPTION_REGISTRATION] = 'Второй экран - С полями регистрации';

        accessPreModeration
            ? options[constants.LOGIN_OPTION_REGISTRATION_PREMODERATION] = 'Третий экран - Заявка принята'
            : options[constants.LOGIN_OPTION_REGISTRATION_SUCCESS] = 'Третий экран - Успешная регистрация';
    }

    return options;
};

export const loginSettingsScreens = (guest) => ({
    [constants.LOGIN_OPTION_INFO]: 'Первый экран (Блок с информацией о мероприятии)',
    [constants.LOGIN_OPTION_EMAIL_REQUEST]: `Первый экран (${guest ? 'Регистрация по имени' : 'Проверка почты'})`,
    [constants.LOGIN_OPTION_REGISTRATION]: 'Второй экран (Поля регистрации)',
    [constants.LOGIN_OPTION_REGISTRATION_SUCCESS]: 'Третий экран "Регистрация пройдена успешно"',
    [constants.LOGIN_OPTION_REGISTRATION_PREMODERATION]: 'Третий экран "Заявка принята"',
    [constants.LOGIN_OPTION_PARTICIPATION_TYPE_SELECT]: 'Экран "Выбор формата участия"',
});

const emailLoginSubtitleAuthRequired = {
    ru: 'Для входа на мероприятие необходимо авторизоваться или зарегистрироваться',
    en: 'To enter the event you must log in or register',
};

const emailLoginSubtitleEnterOnly = {
    ru: 'Для входа на мероприятие необходимо авторизоваться. Пожалуйста, введите почту, указанную при регистрации',
    en: 'To enter the event you must log in. Please enter the email you provided during registration',
};

const emailLoginSubtitleAuthNotRequired = {
    ru: 'Авторизуйтесь или зарегистрируйтесь, чтобы оставлять комментарии, задавать вопросы и участвовать в интерактивах',
    en: 'Log in or register to leave comments, ask questions and participate in interactions',
};

const nameLoginSubtitleAuthRequired = (hasRegistrationFields) => {
    return {
        ru: `Для входа на мероприятие необходимо ${hasRegistrationFields ? 'зарегистрироваться' : 'авторизоваться'}`,
        en: `You must ${hasRegistrationFields ? 'register' : 'log in'} to enter the event`,
    };
};

const nameLoginSubtitleAuthNotRequired = {
    ru: 'Авторизуйтесь, чтобы оставлять комментарии, задавать вопросы и участвовать в интерактивах',
    en: 'Log in to leave comments, ask questions and participate in interactions'
};

export const defaultFirstScreenSubtitle = (guest, authRequire, hasRegistrationFields, enterOnly) => {
    const emailLoginSubtitleAuthReqiered = enterOnly
        ? emailLoginSubtitleEnterOnly
        : emailLoginSubtitleAuthRequired

    const emailLoginSubtitle = authRequire
        ? emailLoginSubtitleAuthReqiered
        : emailLoginSubtitleAuthNotRequired
    ;

    const nameLoginSubtitle = authRequire
        ? nameLoginSubtitleAuthRequired(hasRegistrationFields)
        : nameLoginSubtitleAuthNotRequired
    ;

    return guest
        ? nameLoginSubtitle
        : emailLoginSubtitle;
};

export const defaultParticipationSelectSubtitle = {
    ru: 'Для входа на мероприятие выберите формат участия',
    en: 'To login to the event, select a participation format',
};
